import React, { Component } from 'react';
import OktaSignInWidget from './OktaSignInWidget';
import MFAOptionsContainer from '../../Centralized/common/MFA/MFAOptions/MFAOptionsContainer';
import LoadIndicator from '../../Common/CommonComponents/LoadingIndicator/loadingIndicator';
import classes from './OktaLogin.scss';

class OktaLogin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      promptPopUp: false, showWidget: false,
      widgetInstance:null

    };
   if ((!this.props.popUpWidget) && (app.appService.isAuthenticated() || app.appService. isCpcGuestUser())) {
      app.identityService.sessionService.drupalBasedRedirection();
    }
  }

  clearSession = async () => {
    let widget =  await app.appService.oktaWidget();

    try {
      app.identityService.sessionService.setUpTimers(true); // clears stale timers to avoid refresh call before login
    } catch (error) {
      /* this is intentional */
    }

    
    try {
      await widget.authClient.closeSession();
    } catch (error) {
      /* This is intentional */
    }
    
    try {
      await widget.authClient.idx.cancel();
    } catch (error) {
      /* This is intentional */
    }
    this.setState({ showWidget: true, widgetInstance:widget });
  }

  componentDidMount() {
    const self = this;
    app.pubSubService.subscribe('mfaPopupEnabling', function (msg,data) {
      // prevent double mfa options popup
      if (!document.getElementById('mfa-modal')) {
        self.setState({ ...self.state, promptPopUp: true });
      }
    });
    (!app.appService.isAuthenticated()) && this.clearSession();   
  }

    onSuccess = async (tokens) => {

      const { inlineWidget } = this.props;
      const data = {
        accessToken: tokens.accessToken.accessToken,
        idToken: tokens.idToken.idToken,
        refreshToken: tokens.refreshToken.refreshToken
      };

      app.appService.setSessionstorage('activateReqObj', data);
      app.identityService.sessionService.setUpSessionInfo(data, true, inlineWidget);
    }



    handleCloseMFAOptions = () => {
      this.setState({
        ...this.state, promptPopUp: false
      });
    }

    render() {

      if (app.appService.isAuthenticated()) {
        return null;
      }

      const { promptPopUp, widgetInstance } = this.state;
      const {popUpWidget} = this.props;

      if (promptPopUp) {
        return <MFAOptionsContainer onClose={this.handleCloseMFAOptions} />;
      }

      if(this.state.showWidget){
        //defaultEmailValue - this parameter is for retain the email values, its not a neccessary parameter
        return(
          <div className={classes.heightAndAlignment}>
            <OktaSignInWidget onSuccess={this.onSuccess} defaultEmailValue={this.props.defaultEmailValue} widgetInstance={widgetInstance} popUpWidget={popUpWidget} />
          </div>
        );
      } else {
        return (<div className={classes.heightAndAlignment}>
          <LoadIndicator showLoading />
        </div>);
      }
    }
}

(function () {
  AppModule.init(renderComponent);
  app.appUtil.setFontAwesomeNesting();
})();

function renderComponent() {
  try {
    if (document.getElementById('react-okta-inline')) {
      ReactDOM.render(<OktaLogin inlineWidget />, document.getElementById('react-okta-inline'));
    }

  } catch (error) {
    //Error code
  }
}


export default OktaLogin;
